import { client } from './base/Client';
const campaignUrl = 'campaigns',
  questionUrl = 'questions',
  answerUrl = 'answers',
  authUrl = 'auth';

//GET ALL CAMPAIGNS
const getAllCampaigns = async (filters) => {
  try {
    const response = await client.post(`${campaignUrl}/list`, { filters });
    return response;
  } catch (e) {
    return e.response;
  }
};

//GET CAMPAIGN BY ID
const getCampaignById = async (id) => {
  try {
    const response = await client.get(`${campaignUrl}/${id}`);
    return response;
  } catch (e) {
    return e.response;
  }
};

/**
 * @param {string} campaignId
 */
const getCreatives = async (campaignId) => {
  try {
    const response = await client.get(`${campaignUrl}/${campaignId}/creatives`);
    return response;
  } catch (e) {
    return e.response;
  }
};

//CREATE CAMPAIGN
const createCampaign = async (body) => {
  try {
    const response = await client.post(campaignUrl, body);
    return response;
  } catch (e) {
    return e.response;
  }
};

//UPDATE CAMPAIGN
const updateCampaign = async (body, id) => {
  try {
    const response = await client.patch(`${campaignUrl}/${id}`, body);
    return response;
  } catch (e) {
    return e.response;
  }
};

//DELETE CAMPAIGN
const deleteCampaign = async (body, id) => {
  try {
    const response = await client.post(`${campaignUrl}/${id}`, body);
    return response;
  } catch (e) {
    return e.response;
  }
};

//GET ALL QUESTIONS
const getAllQuestions = async () => {
  try {
    const response = await client.get(questionUrl);
    return response;
  } catch (e) {
    return e.response;
  }
};

//GET QUESTION BY ID
const getQuestionById = async (id) => {
  try {
    const response = await client.get(`${questionUrl}/${id}`);
    return response;
  } catch (e) {
    return e.response;
  }
};

const getQuestionByCampaign = async (id) => {
  try {
    const response = await client.get(`${questionUrl}/campaignQuestion/${id}`);
    return response;
  } catch (e) {
    return e.response;
  }
};

//CREATE QUESTION TOGETHER WITH ITS ANSWERS
const createQuestion = async (body) => {
  try {
    const response = await client.post(questionUrl, body);
    return response;
  } catch (e) {
    return e.response;
  }
};

//UPDATE QUESTION
const updateQuestion = async (body, id) => {
  try {
    const response = await client.patch(`${questionUrl}/${id}`, body);
    return response;
  } catch (e) {
    return e.response;
  }
};

//DELETE QUESTION
const deleteQuestion = async (body, id) => {
  try {
    const response = await client.post(`${questionUrl}/${id}`, body);
    return response;
  } catch (e) {
    return e.response;
  }
};

//GET ALL ANSWERS
const getAllAnswers = async () => {
  try {
    const response = await client.get(answerUrl);
    return response;
  } catch (e) {
    return e.response;
  }
};

//GET ALL ANSWERS BY CAMPAIGN ID
const getAllAnswersByCampaign = async (campaignId) => {
  try {
    const response = await client.get(`${answerUrl}/campaign/${campaignId}`);
    return response;
  } catch (e) {
    return e.response;
  }
};
//GET ANSWER BY ID
const getAnswerById = async (id) => {
  try {
    const response = await client.get(`${answerUrl}/${id}`);
    return response;
  } catch (e) {
    return e.response;
  }
};

const getAnswerByQuestion = async (id) => {
  try {
    const response = await client.get(`${answerUrl}/questionAnswer/${id}`);
    return response;
  } catch (e) {
    return e.response;
  }
};

//CREATE ANSWER
const createAnswer = async (body) => {
  try {
    const response = await client.post(answerUrl, body);
    return response;
  } catch (e) {
    return e.response;
  }
};

//UPDATE ANSWER
const updateAnswer = async (body, id) => {
  try {
    const response = await client.patch(`${answerUrl}/${id}`, body);
    return response;
  } catch (e) {
    return e.response;
  }
};

//DELETE ANSWER
const deleteAnswer = async (body, id) => {
  try {
    const response = await client.post(`${answerUrl}/${id}`, body);
    return response;
  } catch (e) {
    return e.response;
  }
};

const checkEmail = async (body) => {
  try {
    const response = await client.post(authUrl, body);
    return response;
  } catch (e) {
    return e.response;
  }
};

const checkPassword = async (body) => {
  try {
    const response = await client.post(authUrl + '/verify', body);
    return response;
  } catch (e) {
    return e.response;
  }
};

const logOutUser = async (body) => {
  try {
    const response = await client.post(authUrl + '/logout', body);
    return response;
  } catch (e) {
    return e.response;
  }
};

const isUserActive = async (body) => {
  try {
    const response = await client.post(authUrl + '/isActive', body);
    return response;
  } catch (e) {
    return e.response;
  }
};

const getCampaignBenchmarks = async (campaignId) => {
  try {
    const response = await client.get(`${campaignUrl}/${campaignId}/benchmarks`);
    return response;
  } catch (e) {
    return e.response;
  }
};

export {
  checkEmail,
  checkPassword,
  createAnswer,
  createCampaign,
  createQuestion,
  deleteAnswer,
  deleteCampaign,
  deleteQuestion,
  getAllAnswers,
  getAllCampaigns,
  getAllAnswersByCampaign,
  getAllQuestions,
  getAnswerById,
  getAnswerByQuestion,
  getCampaignById,
  getCreatives,
  getQuestionByCampaign,
  getQuestionById,
  getCampaignBenchmarks,
  isUserActive,
  logOutUser,
  updateAnswer,
  updateCampaign,
  updateQuestion
};
